import {
  FETCH_ADMIN_SHARED_TENANTS_REQUEST,
  FETCH_ADMIN_SHARED_TENANTS_SUCCESS,
  FETCH_ADMIN_SHARED_TENANTS_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const fetchAdminSharedTenantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMIN_SHARED_TENANTS_REQUEST:
      return {
        ...state,
        loading: state.data.length === 0,
        error: null,
      };
    case FETCH_ADMIN_SHARED_TENANTS_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_ADMIN_SHARED_TENANTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default fetchAdminSharedTenantsReducer;
